// extracted by mini-css-extract-plugin
module.exports = {"field":"field___2nttQ","name":"name___1TBjV"};